import { ID } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type CompleteExternalConnectionAuthPayload = {
  connectionToken: string;
};

export type CompleteExternalConnectionAuthResponse = {
  connectionId: ID;
};

export type CompleteExternalConnectionAuthOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: CompleteExternalConnectionAuthPayload;
};

// The only authenticated step, so the only one that may decide who owns the connection.
export const completeExternalConnectionAuth = async <TFunctions>(
  options: CompleteExternalConnectionAuthOptions<TFunctions>,
): Promise<CompleteExternalConnectionAuthResponse> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    CompleteExternalConnectionAuthPayload,
    CompleteExternalConnectionAuthResponse
  >(functions, 'externalConnections-completeAuth');

  const { data } = await callable(payload);

  return data;
};
